import { createContext, useContext, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

const PolicyContext = createContext(null);
export const usePolicy = () => useContext(PolicyContext);

const CONTENT = {
  kvkk: {
    title: "KVKK Aydınlatma Metni",
    note: "Aşağıdaki metin bir taslaktır ve yayına almadan önce güncellenmelidir.",
    body: [
      "Hülya Suna Beauty olarak, 6698 sayılı Kişisel Verilerin Korunması Kanunu (“KVKK”) kapsamında veri sorumlusu sıfatıyla hareket ediyoruz.",
      "İletişim ve randevu talepleriniz kapsamında paylaştığınız ad, soyad ve telefon gibi bilgiler; yalnızca randevu talebinizin değerlendirilmesi ve sizinle iletişim kurulması amacıyla işlenir.",
      "Randevu talepleri WhatsApp üzerinden iletildiğinden, ilgili iletişim WhatsApp’ın kendi gizlilik koşullarına da tabidir.",
      "Kişisel verilerinize ilişkin KVKK’dan doğan haklarınız (bilgi talep etme, düzeltme, silme vb.) için bizimle iletişime geçebilirsiniz.",
      "Sağlık verisi gibi özel nitelikli kişisel verilerin bu form aracılığıyla paylaşılmaması önerilir.",
    ],
  },
  gizlilik: {
    title: "Gizlilik Politikası",
    note: "Aşağıdaki metin bir taslaktır ve yayına almadan önce güncellenmelidir.",
    body: [
      "Bu Gizlilik Politikası, Hülya Suna Beauty web sitesini ziyaret ettiğinizde bilgilerinizin nasıl ele alındığını açıklar.",
      "Web sitemiz üzerinden ilettiğiniz randevu talepleri sunucularımızda saklanmaz; yalnızca WhatsApp üzerinden tarafımıza iletilir.",
      "Site deneyimini iyileştirmek amacıyla sınırlı ölçüde çerezler kullanılabilir. Detaylar için Çerez Politikası’na bakınız.",
      "Bilgilerinizin gizliliğine önem veriyor, üçüncü taraflarla pazarlama amacıyla paylaşımını yapmıyoruz.",
    ],
  },
  cerez: {
    title: "Çerez Politikası",
    note: "Aşağıdaki metin bir taslaktır ve yayına almadan önce güncellenmelidir.",
    body: [
      "Web sitemiz, temel işlevselliği sağlamak ve deneyiminizi iyileştirmek için çerezler kullanabilir.",
      "Zorunlu çerezler sitenin düzgün çalışması için gereklidir. Tercihe bağlı çerezler yalnızca onayınızla kullanılır.",
      "Tarayıcı ayarlarınızdan çerezleri dilediğiniz zaman yönetebilir veya silebilirsiniz.",
      "Çerez tercihlerinizle ilgili sorularınız için bizimle iletişime geçebilirsiniz.",
    ],
  },
};

export function PolicyProvider({ children }) {
  const [active, setActive] = useState(null);
  const open = (key) => setActive(key);
  const data = active ? CONTENT[active] : null;

  return (
    <PolicyContext.Provider value={{ open }}>
      {children}
      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-2xl bg-ivory max-h-[85vh] overflow-y-auto" data-testid="policy-modal">
          {data && (
            <>
              <DialogHeader>
                <DialogTitle className="font-serif text-3xl text-espresso">{data.title}</DialogTitle>
                <DialogDescription className="text-gold text-xs tracking-wide">
                  {data.note}
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4 text-espresso/75 text-sm leading-relaxed mt-2">
                {data.body.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </>
          )}
        </DialogContent>
      </Dialog>
    </PolicyContext.Provider>
  );
}
